import { render, staticRenderFns } from "./bookStoreDetails.vue?vue&type=template&id=1a7492de&scoped=true"
import script from "./bookStoreDetails.vue?vue&type=script&lang=js"
export * from "./bookStoreDetails.vue?vue&type=script&lang=js"
import style0 from "./bookStoreDetails.vue?vue&type=style&index=0&id=1a7492de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7492de",
  null
  
)

export default component.exports